export enum IgnoredApiCodes {
    SESSION_INVALID = 10101,
    SESSION_EXPIRED = 10102,
    CSRF_TOKEN_INVALID = 10103,
    LOGIN_FAILED = 10104,
    TWO_FA_VALIDATION_FAILED = 10105,
    API_KEY_INVALID = 10107,
    TWO_FA_LOGIN_REQUIRED = 20312
}
